import React, { Component } from 'react';
import Recaptcha from 'react-recaptcha'
import { Form, Modal } from 'antd'

import AvatarCustom from '../../components/default/AvatarCustom'
import InputCustom from '../../components/default/InputCustom'
import CheckboxCustom from '../../components/default/CheckboxCustom'
import LinkCustom from '../../components/default/LinkCustom'
import ButtonCustom from '../../components/default/ButtonCustom'
import SelectCustom from '../../components/default/SelectCustom'

import { connect } from 'react-redux'
import { register } from '../../actions/user'
import { fetchTitle } from '../../actions/title'

class Register extends Component {
    state = {
        newsCheck: false,
        isVerify: false,
        user: {
            title: "",
            name: "",
            surname: "",
            phone: "",
            email: "",
            password: "",
			confirm_password: "",
            news_status: "false",
            agree: false,
			image: ""
		}
    }

    componentDidMount = () => {
        this.props.fetchTitle()
    }

    onImageChange = (files) =>{
        if(files.length > 0){
            const image = files[0].originFileObj
            let user = { ...this.state.user }
            user.image = image
            this.setState({ user: user })
         }
    }

    onInputChange = (event) => {
        const name = event.target.name
        let user = { ...this.state.user }
        user[name] = event.target.value
        this.setState({user: user})
    }

    handleNewsCheckChange = () => {
        this.setState({ newsCheck: !this.state.newsCheck })
    }

    handleAgreeCheckChange = (event) => {
        let user = { ...this.state.user }
        user.agree = event.target.checked
        this.setState({ user: user })
    }
    
    onVerify = (event) =>{
        this.setState( { isVerify: !this.state.isVerify } )
        //need to send key to verify on server
        // console.log(event)
    }

    callback = (e) => {}

    onSubmit = (e) => {
        e.preventDefault()
        const {isVerify} = this.state
		let user = { ...this.state.user }
        user.news_status = "" + this.state.newsCheck
        if(!user.agree){
            Modal.error({
                title: 'Terms and Conditions',
                content: 'Please agree to terms and conditions.',
            })
            return false
        }

        if(user.password !== user.confirm_password){
            Modal.error({
                title: 'Password',
                content: 'password does not match.',
            })
            return false
        }

        if(isVerify === false){
            Modal.error({
                title: 'Verifying Humanity',
                content: 'please verify your humanity',
            })
            return false
        }

        this.props.register(user)
    }
    
    onTitleChange = (id) => {
        let user = { ...this.state.user }
        user.title = id
        this.setState({ user })
    }

    render() {
        const { name, agree } = this.state.user

        return (
            <Form onSubmit={this.onSubmit}>
                <div className="login-section-wrap">
                    <div className="login-section">
                        <div className="login-section-title">สมัครสมาชิก</div>
                        <div className="login-section-sub-title">กรุณาระบุข้อมูลดังต่อไปนี้เพื่อสร้างบัญชีผู้ใช้ในระบบ</div>
                        <div className="gapt-32 gapb-32 is-row flex-center">
                            <AvatarCustom name={name} onChange={this.onImageChange}/>
                        </div>
                        <div className="is-row gapb-14 flex-align-end">
                            <div className="is-24 is-sm-100 gapr-8 sm-gapr-0 sm-gapb-14">
                                <SelectCustom
                                    label="ชื่อ - สกุล"
                                    labelColor="65"
                                    marginBottom="0"
                                    placeholder="นาย"
                                    size="large"
                                    required
                                    onChange={this.onTitleChange}
                                    option={this.props.title.map((title) => {
                                        return { value: title.id, label: title.title }
                                    })} />
                            </div>
                            <div className="is-38 gapr-4">
                                <InputCustom
                                    size="large"
                                    type="text"
                                    required
                                    placeholder="ชื่อ"
                                    marginBottom="0"
                                    name="name"
                                    onChange={this.onInputChange}
                                />
                            </div>
                            <div className="is-38">
                                <InputCustom
                                    placeholder="นามสกุล"
                                    size="large"
                                    type="text"
                                    required
                                    marginBottom="0"
                                    name="surname"
                                    onChange={this.onInputChange}
                                />
                            </div>
                        </div>
                        <InputCustom
                            label="โทรศัพท์"
                            labelColor="65"
                            size="large"
                            type="text"
                            required
                            placeholder="โทรศัพท์"
                            marginBottom="16"
                            name="phone"
                            onChange={this.onInputChange}
                        />
                        <InputCustom
                            label="อีเมล"
                            labelColor="65"
                            size="large"
                            type="text"
                            required
                            placeholder="อีเมล"
                            marginBottom="16"
                            name="email"
                            onChange={this.onInputChange}
                        />
                        <InputCustom
                            label="รหัสผ่าน"
                            labelColor="65"
                            size="large"
                            type="password"
                            required
                            placeholder="รหัสผ่าน"
                            marginBottom="16"
                            name="password"
                            onChange={this.onInputChange}
                        />
                        <InputCustom
                            label="ยืนยันรหัสผ่าน"
                            labelColor="65"
                            size="large"
                            type="password"
                            required
                            placeholder="ยืนยันรหัสผ่าน"
                            marginBottom="16"
                            name="confirm_password"
                            onChange={this.onInputChange}
                        />
                        <div className="hr gapt-40 gapb-32"></div>
                        <div className="gapb-16">
                            <CheckboxCustom
                                checked={this.state.newsCheck}
                                onChange={this.handleNewsCheckChange}
                                label="ต้องการรับข่าวสาร และ ข้อมูลใหม่ๆ ผ่านอีเมล"/>
                        </div>
                        <div>
                            <CheckboxCustom
                                checked={agree}
                                onChange={this.handleAgreeCheckChange}
                                label="ข้าพเจ้าเข้าใจและยอมรับ"
                                render={< LinkCustom label="เงื่อนไขการใช้งาน" link="/" />} />
                        </div>
                        <div className="gapt-32 gapb-32">
                            <Recaptcha
                                className="recaptcha-wrap"
                                sitekey="6LcWonkUAAAAANWpCP2254xnRFxTvgw17pXh1cIN"
                                render="explicit"
                                onloadCallback={this.callback}
                                verifyCallback={this.onVerify}
                                size="normal"
                            />
                        </div>
                        <div className="gapb-24">
                            <ButtonCustom
                                borderRadius="4"
                                color="blue"
                                label="สร้างบัญชีผู้ใช้"
                                fontSize={14}
                                fontWeight="Bold"
                                size="large"
                                htmlType="submit"
                            />
                        </div>
                        <div className="gapt-24 textAlign-center">
                            <LinkCustom label="เข้าสู่ระบบ" link="/login" />
                        </div>
                    </div>
                </div>
            </Form>
            
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        user: state.user,
        title: state.title
    }
}

const mapDispatchToProps = {
    register,
    fetchTitle
}

export default connect(mapStateToProps, mapDispatchToProps)(Register)
